export const PAGINATION_SIZE = 10;

export const API_MEASURE_RTSYNONYMS = 'RtSynonyms';
export const API_MEASURE_AROUSAL = 'Arousal';
export const API_MEASURE_READABILITY = 'Readability';
export const API_MEASURE_RTSPELLING = 'RtSpellingGrammar';
export const API_MEASURE_TOPICS = 'Topics';
export const API_MEASURE_WORDSCOUNT = 'WordsCount';
export const API_SUMMARYISSUES = 'summaryIssues';
export const API_SUMMARYISSUES_CRITICAL = 'critical';
export const API_SUMMARYISSUES_STYLISTIC = 'stylistic';

export const BLOG_CONTENT_TYPE = 'article';

export const FETCH_ERROR = 'FETCH_ERROR';

export const HUBSPOT = 'HUBSPOT';
export const WORDPRESS = 'WORDPRESS';
export const AR = 'AR';

export const TRACK_JS_KEY = process.env.REACT_APP_TRACKJS_KEY;

export const ADS_EDITOR_SIDEBAR_MODES = {
  multiselect: 'multiselect',
  sinlgeselect: 'sinlgeselect',
};

export const USERFLOW_DEV = process.env.REACT_APP_USERFLOW_TOKEN;
export const USERFLOW_PRODUCTION = process.env.REACT_APP_USERFLOW_TOKEN;

export const DEFAULT_PROFILE_NAME = 'Universal Profile';

export const MAGIC_LINK_INFLUENCER_DISPLAY = ['accepted', 'recommended'];
